"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.quickOffer.name': 'Quick Offer',
    'tools.quickOffer.description': 'Collect quick offer form fields from user messages based on configured fields and options',
};
